module.exports = __webpack_public_path__ + "img/arrow_left.9bc6ae4e.svg";